function state() {
  return {
    invoice: {},
    invoiceList: [],
    invoiceListMeta: {},
  };
}

export default state;
